import React from 'react';
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Text,
  Flex,
} from '@chakra-ui/react';
import { useFeatureFlagFromContext } from '../../../launchdarkly';
import ReskinnedBenchmarkOWStat from './ReskinnedBenchmarkOWStat';

const BenchmarkOWStat = props => {
  // All hooks must be called at the top level
  const showReskin = useFeatureFlagFromContext('showReskin', false);

  // If showReskin feature flag is enabled, render the reskinned version
  if (showReskin) {
    return <ReskinnedBenchmarkOWStat {...props} />;
  }

  return (
    <Card width={'100%'}>
      <CardHeader bgColor={props.bgColor} p={1}>
        <Text fontSize={'sm'} fontWeight={'bold'}>
          {props.header}
        </Text>
      </CardHeader>
      <CardBody p={10} bgColor={props.bgColor}>
        <Flex direction={'column'}>
          <Flex gap={1} justifyContent={'center'} alignItems={'center'}>
            <Flex>
              <Text fontSize={'2xl'} textColor={'red.400'} fontWeight={'bold'}>
                {props.num === undefined ? '-' : props.num}
              </Text>
            </Flex>
            <Flex>
              <Text fontSize={'2xl'}>/</Text>
            </Flex>
            <Flex>
              <Text
                fontSize={'2xl'}
                textColor={'green.400'}
                fontWeight={'bold'}
              >
                {props.denom === undefined ? '-' : props.denom}
              </Text>
            </Flex>
          </Flex>
          <Flex gap={1} justifyContent={'center'} alignItems={'center'}>
            <Flex>
              <Text fontSize={'xs'} textColor={'red.400'} fontWeight={'bold'}>
                {props.numDesc}
              </Text>
            </Flex>
            <Flex>
              <Text fontSize={'xs'}>/</Text>
            </Flex>
            <Flex>
              <Text fontSize={'xs'} textColor={'green.400'} fontWeight={'bold'}>
                {props.denomDesc}
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </CardBody>

      <CardFooter justifyContent={'center'} bgColor={props.bgColor}>
        <Flex m={2}>
          <Text fontSize={'xs'} style={{ color: 'green' }} textAlign={'center'}>
            {props.footer}
          </Text>
        </Flex>
      </CardFooter>
    </Card>
  );
};

export default BenchmarkOWStat;
